import Reveal from "@/components/feature/Reveal";
import { evidenceEntries } from "@/mocks/homeStats";

const accentIconMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

const accentCountMap: Record<string, string> = {
  primary: "text-primary-700",
  accent: "text-accent-800",
  secondary: "text-secondary-800",
};

export default function EntryGrid() {
  return (
    <section id="entries" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-widest text-primary-600">
                TYPE ENTRANCE
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                按材料类型进入
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              截图、录音、文件、线索分开归档，先按类型定位，再回到汇总里做交叉核对，比一页页翻要快得多。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {evidenceEntries.map((entry, index) => (
            <Reveal key={entry.id} delay={index * 60}>
              <a
                href="#cases"
                className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md ${
                      accentIconMap[entry.accent] ?? accentIconMap.primary
                    }`}
                  >
                    <i className={`${entry.icon} text-xl`}></i>
                  </span>
                  <span
                    className={`font-heading text-lg font-bold ${
                      accentCountMap[entry.accent] ?? accentCountMap.primary
                    }`}
                  >
                    {entry.count}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-medium text-foreground-950">{entry.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {entry.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-primary-700">
                  查看该类材料
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}